import {getToken} from "../utils/auth";

const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  // options.js
  interval: state => state.options.interval,
  coupon: state => state.options.coupon,
  luckyDraw: state => state.options.luckyDraw,
  orderStatus: state => state.options.orderStatus,
  orderType: state => state.options.orderType,
  couponUseType: state => state.options.couponUseType,
  printerType: state => state.options.printerType,
  deviceBrand: state => state.options.deviceBrand,
  publishStatus: state => state.options.publishStatus,
  couponStatus: state => state.options.couponStatus,

  uploadHeaders: state => state.app.uploadHeaders || {Authorization:getToken()}
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js